import { RouteType } from '../types/navigation';

interface Routes {
  WELCOME: RouteType;
  FAQ: RouteType;
  ONBOARDING: RouteType;
  CLIENT_ONBOARDING: RouteType;
  PROFILE: RouteType;
  PREVIEW: RouteType;
  SESSIONS: RouteType;
  AVAILABILITY: RouteType;
  ADMIN: RouteType;
  HELP: RouteType;
  NOTIFICATIONS: RouteType;
  SETTINGS: RouteType;
  INSTANT_STYLING: RouteType;
  MESSAGES: RouteType;
  MESSAGE: (channelUrl: string) => RouteType;
  WELCOME_INTRO: (welcomeSlug: string) => RouteType;
  EXPLORE: RouteType;
  CLOSE_SCREEN: RouteType;
  PRIVACY: RouteType;
  TERMS: RouteType;
  VIDEO_SESSION: RouteType;
  CLIENT_NOTES: (clientId: string) => RouteType;
  NOT_A_NORMAL_SHOW: RouteType;
  STYLIST_PREVIEW: (shareCode: string) => RouteType;
}

export const ROUTES: Routes = {
  WELCOME: {
    path: '/welcome',
    name: 'welcome',
  },
  FAQ: {
    path: '/faq',
    name: 'faq',
    label: 'FAQ',
  },
  WELCOME_INTRO: (welcomeSlug) => ({
    path: `/welcome-intro/${welcomeSlug}`,
    name: `welcome-intro`,
  }),
  MESSAGE: (channelUrl) => ({
    path: `/messages/${channelUrl}`,
    name: `message`,
  }),
  ONBOARDING: {
    path: '/onboarding',
    name: 'onboarding',
  },
  CLIENT_ONBOARDING: {
    path: '/client-onboarding',
    name: 'client-onboarding',
  },
  PROFILE: {
    path: '/profile',
    name: 'profile',
    label: 'Your Profile',
  },
  PREVIEW: {
    path: '/preview',
    name: 'preview',
    label: 'Your Profile',
  },
  SESSIONS: {
    path: '/sessions',
    name: 'sessions',
    label: 'Sessions',
  },
  AVAILABILITY: {
    path: '/availability',
    name: 'availability',
    label: 'Set Availability',
  },
  ADMIN: {
    path: '/admin',
    name: 'admin',
    label: 'Dashboard',
  },
  HELP: {
    path: '/help',
    name: 'help',
    label: 'Help Center',
  },
  NOTIFICATIONS: {
    path: '/notifications',
    name: 'notifications',
    label: 'Notifications',
  },
  SETTINGS: {
    path: '/settings',
    name: 'settings',
    label: 'Settings',
  },
  INSTANT_STYLING: {
    path: '/instant-styling',
    name: 'instant-styling',
    label: 'Instant Styling',
  },
  MESSAGES: {
    path: '/messages',
    name: 'messages',
    label: 'Messages',
  },
  EXPLORE: {
    path: '/explore',
    name: 'explore',
    label: 'Explore',
  },
  CLOSE_SCREEN: {
    path: '/close-screen',
    name: 'close-screen',
    label: 'Close Screen',
  },
  PRIVACY: {
    path: '/privacy',
    name: 'privacy',
    label: 'Privacy Policy',
  },
  TERMS: {
    path: '/terms',
    name: 'terms',
    label: 'Terms of Service',
  },
  VIDEO_SESSION: {
    path: '/video-session',
    name: 'video-session',
    label: 'Video Session',
  },
  CLIENT_NOTES: (clientId) => ({
    path: `/client-notes/${clientId}`,
    name: 'client-notes',
    label: 'Private Notes',
  }),
  NOT_A_NORMAL_SHOW: {
    path: '/not-a-normal-show',
    name: 'not-a-normal-show',
    label: 'Not A Normal Show',
  },
  STYLIST_PREVIEW: (shareCode) => ({
    path: `/stylist-preview/${shareCode}`,
    name: 'stylist-preview',
  }),
};
